import { render, staticRenderFns } from "./ElementsToDeleteForm.vue?vue&type=template&id=18a3c1b6"
import script from "./ElementsToDeleteForm.vue?vue&type=script&lang=js"
export * from "./ElementsToDeleteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports